import disciplines from './components/disciplines';

export default {
  routes: [
    {
      path: '/',
      component:disciplines,
      name:'disciplines'
    },
  ]
};